export default __webpack_public_path__ + "media/flags/cy-5322bdf8.svg";